import React, { useState, Fragment, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
// import { CommonConfig } from '../../../config/common-config';
import axios from 'axios';
import { Button, Paper, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import FormControl from '@material-ui/core/FormControl';
// import InputForm from './components/InputForm';
// import EditForm from './components/EditForm';
// import TableUser from './components/TableUser';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';


import '../styles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        minWidth: '250px',
    },
    btnspace: {
        margin: '50px 0 !important',
        width: '100%',
    },
}));

export default function PreEngagementDocument() {
    const classes = useStyles();
    return (
        <>
            <Card className={classes.root}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <Typography className="final-doc-title">Pre-Engagement Document</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl className={classes.btnspace}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                >
                                    Attach Document
                                                    </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <div className="footer-button">
                <ul>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" type="submit">
                            Upload
                        </Button>
                    </li>
                </ul>
            </div>
                            <div className="document-container">
                                <div className="document-title">
                                    Pre-Engagement Document 1
                                </div>                                
                                <div className="document-action">
                                    <FontAwesomeIcon icon={faFileAlt} size="2x" />
                                     <FontAwesomeIcon icon={faTrashAlt} size="2x" />                                    
                                </div>
                                <div className="clear" />
                            </div>                            
  
        </>
    );
}
